import React from "react";
import PropTypes from "prop-types";

const Checkbox = ({
  name,
  title,
  type,
  value,
  label,
  error,
  handleChange,
  placeholder,
  className,
  page
}) => {
  console.log(name, value)
  
  return (
    <div className="text-start mt-2">
      <label className="form-check form-check-custom form-check-inline form-check-solid mx-2 mb-0">
        <input
          className="form-check-input"
          name={name}
          type="checkbox"
          checked={!!value}
          onChange={(e) => {
           
            handleChange({name: name, checked: e.target.checked})
          }}
        />
        <span className=" ps-2 fs-12 form-label">{label}</span>
      </label>
      
      <div style={page ? { height: "20px" } : {}}>
        <span className="fs-10 text-danger">{error}</span>
      </div>
    </div>
    // <div className="text-start">
    //   <label className="form-check ps-0 form-check-solid">
    //     <input
    //       className=""
    //       name={name}
    //       type="checkbox"
    //       value="1"
    //     />
    //     <span className="ms-2 fs-12 form-label">{label}</span>
    //   </label>

    //   <span className="fs-10 text-danger">{error}</span>
    // </div>
  );
};

Checkbox.prototype = {
  name: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string,
  error: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  page: PropTypes.string
};
export default Checkbox;
